import { SeatInfo } from "@/domain/entities/book/seatInfo";
import { ISeatInfo } from "@/domain/entities/book";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { err, ok, Result } from "neverthrow";
import { HttpSeatInfo, ISeatsInfoParser } from "../bookRepository.types";
import { injectable } from "inversify";

export function parseSeatsInfo(
  seatsInfosData: HttpSeatInfo[][][]
): ISeatInfo[][][] {
  const seatsInfoList: ISeatInfo[][][] = [];
  const floorSeatsInfo: ISeatInfo[][] = [];

  seatsInfosData.forEach((seatsData) => {
    seatsData.map((seatsRowList) => {
      const seatInfos: ISeatInfo[] = [];
      seatsRowList.map((seat) => {
        const info: ISeatInfo = {
          bookedBySomeone: !seat?.myBookedYn && seat?.bookedYn,
          bookedByMe: seat?.myBookedYn,
          floorNo: seat?.floorNo,
          rowNo: seat?.rowNo,
          columnNo: seat?.columnNo,
          seatNo: seat?.seatNo,
        };
        const seatInfo = new SeatInfo(info);
        seatInfos.push(seatInfo);
      });
      floorSeatsInfo.push(seatInfos);
    });
    seatsInfoList.push(floorSeatsInfo);
  });

  return seatsInfoList;
}

@injectable()
export class SeatsInfoParser implements ISeatsInfoParser {
  constructor() {}

  toDomain(
    data: Array<HttpSeatInfo[][]>
  ): Result<Array<ISeatInfo[][]>, ParseError> {
    try {
      const seatInfosList = parseSeatsInfo(data);
      return ok(seatInfosList);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
